import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Mail, AlertTriangle } from "lucide-react";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function AuthMagicLink() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const [error, setError] = useState(null);

  useEffect(() => {
    const token = params.get("token");
    if (!token) {
      setError("Missing sign-in token. Request a new link from the sign-in page.");
      return;
    }
    let cancelled = false;
    (async () => {
      try {
        const r = await api.post("/auth/magic-link/verify", { token });
        if (cancelled) return;
        setUser(r.data);
        const dest = r.data?.redirect_path || "/dashboard";
        navigate(dest, { replace: true });
      } catch (e) {
        if (cancelled) return;
        setError(e?.response?.data?.detail || "We couldn't sign you in with that link.");
      }
    })();
    return () => { cancelled = true; };
  }, [params, navigate, setUser]);

  if (error) {
    return (
      <div className="min-h-screen grid place-items-center p-6 bg-yellow-50">
        <div className="nb-card p-8 max-w-md w-full text-center bg-white" data-testid="magic-link-error">
          <div className="w-14 h-14 mx-auto bg-pink-300 border-2 border-slate-900 rounded-md grid place-items-center" style={{ boxShadow: "3px 3px 0 0 #0F172A" }}>
            <AlertTriangle className="w-7 h-7" strokeWidth={2.5}/>
          </div>
          <h1 className="font-display text-2xl font-black mt-4">Sign-in link didn't work</h1>
          <p className="text-sm font-medium text-slate-700 mt-3">{error}</p>
          <a href="/login" data-testid="magic-link-back" className="nb-btn-primary mt-6 inline-flex items-center gap-2">Back to sign-in</a>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen grid place-items-center p-6 bg-yellow-50">
      <div className="nb-card p-8 max-w-md w-full text-center bg-white" data-testid="magic-link-loading">
        <div className="w-14 h-14 mx-auto bg-yellow-300 border-2 border-slate-900 rounded-md grid place-items-center" style={{ boxShadow: "3px 3px 0 0 #0F172A" }}>
          <Mail className="w-7 h-7" strokeWidth={2.5}/>
        </div>
        <h1 className="font-display text-2xl font-black mt-4">Signing you in…</h1>
        <p className="text-sm font-medium text-slate-700 mt-3">Hold on a second.</p>
      </div>
    </div>
  );
}
